export const PARTICIPANT_TAB_ALL = 'all'
export const PARTICIPANT_TAB_ACTIVE = 'active'
// Значения — из контракта участника (`tab=all|active|finished`). `past` бэк
// тоже понимает как синоним, но документирован именно `finished`; проверено
// пробами 2026-08-08. Неизвестное значение бэк молча трактует как «все».
export const PARTICIPANT_TAB_FINISHED = 'finished'

/** Сортировка завершённых: последние сверху (решение владельца 2026-10-11). */
export const FINISHED_ORDERING = '-schedule_start'

export interface ParticipantOlympiadListParams {
  tab?: string
  ordering?: string
}

/** Параметры запроса на вкладку.
 *
 *  «Все олимпиады» просит у бэка `active`, а не «всё подряд»: завершённые
 *  должны жить только в своей вкладке (решение владельца 2026-08-09). Своего
 *  «всё, кроме завершённых» у контракта нет, а фильтровать на клиенте нельзя —
 *  счётчик и число страниц приходят от бэка и разъехались бы со списком.
 *  Проба стенда 2026-08-09: `active` и `upcoming` дают одно и то же (3 из 5),
 *  `past` — оставшиеся 2.
 *
 *  Порядок задаёт бэк (с 11.10): по личному старту участника по возрастанию,
 *  без расписания — в конце, поэтому «Все» и «Активные» `ordering` не шлют.
 *  У «Завершённых» порядок обратный — `ordering=-schedule_start`. */
export function participantListParams(tab: string): ParticipantOlympiadListParams {
  if (tab === PARTICIPANT_TAB_FINISHED) return { tab, ordering: FINISHED_ORDERING }
  return { tab: tab === PARTICIPANT_TAB_ALL ? PARTICIPANT_TAB_ACTIVE : tab }
}
